import type { Motif, MotifComponentProps } from '@snapchat/snap-design-system-marketing';
import {
  contrastBlackButtonVars,
  darkThemeHeaderVars,
  defaultMotif,
  FontFamily,
  m,
  mergeMotifs,
  MotifComponent,
  MotifScheme,
} from '@snapchat/snap-design-system-marketing';

const headerSiteNameVars: Partial<MotifComponentProps<MotifComponent.HEADER>> = {
  '--global-header-site-name-font-family': 'inherit',
  '--global-header-site-name-font-size': m('--action-desktop-font-size'),
};

/** Motif for the Pixy website. */
export const cheeriosMotif: Motif = mergeMotifs(defaultMotif, {
  name: 'Pixy',
  fontFamily: [FontFamily.BUENOS_AIRES],
  [MotifScheme.DEFAULT]: {
    name: 'Default Pixy Scheme',
    [MotifComponent.ROOT]: {
      '--font-family': FontFamily.BUENOS_AIRES,
      '--h1-font-family': FontFamily.BUENOS_AIRES,
      '--h2-font-family': FontFamily.BUENOS_AIRES,
      '--h3-font-family': FontFamily.BUENOS_AIRES,
      '--h4-font-family': FontFamily.BUENOS_AIRES,
      '--h5-font-family': FontFamily.BUENOS_AIRES,
      '--h6-font-family': FontFamily.BUENOS_AIRES,
      '--text-desktop-font-line-height': '200%',
      '--h2-desktop-font-size': '48px',
      '--h2-desktop-font-line-height': '120%',
      '--h2-desktop-font-stretch': 'normal',
      '--h2-desktop-font-text-transform': 'none',
      '--h2-desktop-font-letter-spacing': 'normal',
      '--h2-mobile-font-size': '40px',
      '--h2-mobile-font-line-height': '120%',
      '--h2-mobile-font-stretch': 'normal',
      '--h2-mobile-font-text-transform': 'none',
      '--h2-mobile-font-letter-spacing': 'normal',
      '--h3-desktop-font-weight': '500',
      '--h3-mobile-font-size': '28px',
      '--h3-mobile-font-weight': '500',
      '--h4-desktop-font-weight': '500',
      '--h4-mobile-font-size': '24px',
      '--h4-mobile-font-weight': '500',
      '--h5-desktop-font-size': '24px',
      '--h5-desktop-font-weight': '500',
      '--h5-mobile-font-weight': '500',
      '--h6-desktop-font-weight': '500',
      '--h6-mobile-font-weight': '500',
    },
    [MotifComponent.HEADER]: headerSiteNameVars,
  },
  [MotifScheme.SECONDARY]: {
    name: 'Pixy Transparent Background. Light Text.',
    [MotifComponent.ROOT]: {
      '--bg-color': m('--palette-plain-transparent'),
      '--fg-color': m('--neutral-v0'),
    },
    [MotifComponent.BUTTON]: contrastBlackButtonVars,
    [MotifComponent.HEADER]: { ...darkThemeHeaderVars, ...headerSiteNameVars },
  },
});
